module.exports = __webpack_public_path__ + "static/media/finance_use_case_2.3601c4bf.svg";